import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { AllQualityIssue } from '../models/all-quality-issue';
import { AllQualityIssueBatch } from '../models/all-quality-issue-batch';
import { AllQualityIssueService } from '../services/all-quality-issue.service';

export const qualityIssueResolver: ResolveFn<AllQualityIssue> = async (route: ActivatedRouteSnapshot) => {
	const claimService = inject(AllQualityIssueService);
	const params = <{ claimId?: string }> route.params;
	const claimIdParam = params['claimId'];
	if (claimIdParam) {
		const claimId = Number(claimIdParam);
		if (claimService.claim.steeluserId !== claimId) {
			const claim = await firstValueFrom(claimService.getClaimBySteeluserId(claimId));
			claimService.claim = new AllQualityIssue();
			Object.assign(claimService.claim, {
				...claim,
				batches: claim.batches.map(batch => Object.assign(new AllQualityIssueBatch(), batch))
			});
		}
	}
	return claimService.claim;
};
